import React from "react";
import BackToTop from "./BackToTop";
import { useTranslation } from "react-i18next";
import "../../stylesheet/components/singlecomponents/ShareButtons.scss";
import { ReactComponent as TwitterLogo } from "../../assets/ShareButton/twitter.svg";
import { ReactComponent as FacebookLogo } from "../../assets/ShareButton/facebook.svg";
import { ReactComponent as TelegramLogo } from "../../assets/ShareButton/telegram.svg";
import { ReactComponent as InstaLogo } from "../../assets/ShareButton/instagram.svg";

const FooterCommunity: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="d-flex h-75 flex-lg-column justify-content-between position-relative">
      <div className="col-md-4 col-lg-12">
        <h5>{t("footer.zecommunity")}</h5>
        <div className="d-flex justify-content-between">
          <a href={"https://twitter.com/zefihub"} target="_blank">
            <TwitterLogo className="share-button twitter" />
          </a>
          <a href={"https://www.facebook.com/ZeFiHub/"} target="_blank">
            <FacebookLogo className="share-button fb" />
          </a>
          <a href={"https://t.me/ZefiHub/"} target="_blank">
            <TelegramLogo className="share-button telegram" />
          </a>
          <a
            href={"https://www.instagram.com/zefihub/?hl=en"}
            target={"_blank"}
          >
            <InstaLogo className="share-button insta" />
          </a>
        </div>
      </div>
      <BackToTop />
    </div>
  );
};

export default FooterCommunity;
